/**
 * PCM Streamer utility to convert browser microphone stream to 16kHz Int16 PCM.
 * Based on common Web Audio API patterns for real-time STT.
 */

export function createPcmStreamer(stream, onFrame) {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)({
        sampleRate: 16000, // Request 16kHz from the start if supported
    });

    const source = audioContext.createMediaStreamSource(stream);

    // ScriptProcessorNode is deprecated but still widely used for simple ports.
    // Using 4096 buffer size for balance between latency and performance.
    const processor = audioContext.createScriptProcessor(4096, 1, 1);

    processor.onaudioprocess = (e) => {
        const inputData = e.inputBuffer.getChannelData(0); // Float32Array
        const pcmData = float32ToInt16(inputData);
        onFrame(pcmData.buffer);
    };

    source.connect(processor);
    processor.connect(audioContext.destination);

    return {
        stop: () => {
            source.disconnect();
            processor.disconnect();
            if (audioContext.state !== 'closed') {
                audioContext.close();
            }
        },
    };
}

/**
 * Converts Float32 audio samples to Int16 PCM.
 */
function float32ToInt16(buffer) {
    let l = buffer.length;
    let buf = new Int16Array(l);
    while (l--) {
        let s = Math.max(-1, Math.min(1, buffer[l]));
        buf[l] = s < 0 ? s * 0x8000 : s * 0x7FFF;
    }
    return buf;
}
